(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      const tagFilterRoot = document.querySelector('results-list[data-url-filter-active]');
      const allCollectionRoot = document.querySelector('results-list[data-all-collection-root]');

      const pruneSiblingHeroSections =
        tagFilterRoot ||
        (allCollectionRoot && !allCollectionRoot.hasAttribute('data-url-filter-active'));

      if (!pruneSiblingHeroSections) return;

      const resultsRoot = tagFilterRoot ?? allCollectionRoot;

      const selector =
        '.section-content-wrapper.mobile-column.layout-panel-flex.layout-panel-flex--column.spacing-style';

      document.querySelectorAll(selector).forEach((el) => {
        if (el.closest('results-list') === resultsRoot) return;
        if (el.contains(resultsRoot)) return;
        const host = el.closest('.shopify-section');
        if (!(host instanceof HTMLElement)) return;

        if (host.querySelector('[data-collection-page-heading]')) return;

        host.hidden = true;
        host.setAttribute('aria-hidden', 'true');
      });
    },
    { once: true }
  );

  } catch(e) { console.error(e); }
})();
})();
